import React, { useReducer } from 'react';
/**
 * Create a state provider
 */
export function createProvider(stateContext, dispatchContext, reducer, initialState) {
    var component = function (_a) {
        var children = _a.children;
        var _b = useReducer(reducer, initialState), s = _b[0], d = _b[1];
        var state = React.useMemo(function () { return s; }, [s]);
        var dispatch = React.useMemo(function () { return d; }, [d]);
        return (React.createElement(stateContext.Provider, { value: state },
            React.createElement(dispatchContext.Provider, { value: dispatch }, children)));
    };
    component.displayName = 'CustomProvider';
    return component;
}
//# sourceMappingURL=createProvider.js.map